export function mixWithWhite(hex: string, ratio: number): string {
  // Split into r, g, b components
  const rgb = hex
    .replace('#', '')
    .match(/.{2}/g)
    ?.map((x) => parseInt(x, 16)) ?? [0, 0, 0];
  // Mix each component with white
  const mixed = rgb.map((c) => Math.round(c * (1 - ratio) + 255 * ratio));
  // Convert back to hex
  return (
    '#' +
    mixed
      .map((x) => x.toString(16).padStart(2, '0'))
      .join('')
      .toUpperCase()
  );
}
